var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-detail-info-one"},[_vm._t("header-one"),_c('div',{staticClass:"home-detail-info-one-text"},[_vm._t("text-one"),_vm._t("image")],2),_vm._t("header-two"),_c('div',{staticClass:"home-detail-info-one-text"},[_vm._t("text-two")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }